import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Typography, Box } from '@mui/material';

import apis from '@src/apis';
import { PACKAGE_TYPE } from '@src/constants/package';
import { checkVietNam } from '@src/utils/checkCountry';
import SubscriptionSMSItem from './SubscriptionSMSItem';
import { StyledSubscription } from './index.style';
import SMSCancelDialog from '../Dialog/SMSCancelPopup';

const Subscription = () => {
  const [openDialog, setOpenDialog] = useState(false);
  const [usingOrders, setUsingOrders] = useState([]);
  const [selectedOrder, setSelectedOrder] = useState({});

  const handleOpenDialog = (orderInfo) => {
    setOpenDialog(true);
    setSelectedOrder(orderInfo);
  };

  const isVietNam = checkVietNam();

  const { subscriptionPurchase } = useSelector((state) => state.user);

  const { t } = useTranslation();

  const handleSetUsingOrders = (currUsingOrders) => {
    const sortedOrders = currUsingOrders.sort((a, b) => {
      if (
        a?.package?.type === PACKAGE_TYPE.MBF_STUDIO &&
        b?.package?.type !== PACKAGE_TYPE.MBF_STUDIO
      ) {
        return -1;
      }
      if (
        b?.package?.type === PACKAGE_TYPE.MBF_STUDIO &&
        a?.package?.type !== PACKAGE_TYPE.MBF_STUDIO
      ) {
        return 1;
      }
      return 0;
    });

    setUsingOrders(sortedOrders);
  };

  const fetchUsingOrders = async () => {
    const data = await apis.orders.getUsingOrders();
    if (data && data.status) {
      handleSetUsingOrders(data.result);
    }
  };

  useEffect(() => {
    fetchUsingOrders();
  }, []);

  return (
    <StyledSubscription>
      <div className="header-payment">
        <Typography className="title">{t('myPackages')}</Typography>
      </div>
      <Box className="using-package-list">
        {usingOrders.map((usingOrder) => (
          <Box key={usingOrder.id}>
            <SubscriptionSMSItem
              packageInfo={usingOrder?.package}
              usingOrder={usingOrder}
              isVietNam={isVietNam}
              subscriptionPurchase={subscriptionPurchase}
              handleOpenDialog={handleOpenDialog}
            />
          </Box>
        ))}
      </Box>
      <SMSCancelDialog
        selectedOrder={selectedOrder}
        openDialog={openDialog}
        setOpenDialog={setOpenDialog}
      />
    </StyledSubscription>
  );
};

export default Subscription;
